import type { PageInfo } from '../../common/types';

/**
 * rowData에 고유 ID를 추가합니다
 */
export const addUniqueId = (rowData: any[]): any[] => {
  return rowData?.map((row, index) => ({
    ...row,
    uniqueId: row.uniqueId ?? index + 1,
  }));
};

/**
 * rowData에 rowNumber를 추가합니다
 */
export const addRowNumber = (
  rowData: any[],
  pageInfo?: PageInfo | null
): any[] => {
  return rowData?.map((row, index) => {
    if (row.rowNumber !== undefined) return row;

    let rowNumber: number;
    if (!pageInfo) {
      rowNumber = index + 1;
    } else {
      rowNumber = Math.max(
        1,
        (pageInfo.totalItems || 0) -
          (pageInfo.pageSize || 0) * ((pageInfo.pageNo || 0) - 1) -
          index
      );
    }

    return {
      ...row,
      rowNumber,
    };
  });
};

/**
 * rowData에 checkbox 필드를 추가합니다
 */
export const addCheckboxField = (rowData: any[]): any[] => {
  return rowData?.map(row => ({
    ...row,
    checkbox: row.checkbox ?? false,
  }));
};
